import { Header } from "@obs/base";
import { Locale } from "@obs/providers";
import * as stylex from "@stylexjs/stylex";
import { createRootRoute, Outlet } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useIntl } from "react-intl";

import { GoogleTagManager } from "../components/GoogleTagManager";
import { UnexpectedError } from "../components/UnexpectedError";

const styles = stylex.create({
	layout: {
		display: "flex",
		height: "100dvh",
		flexDirection: "column",
	},
});

const FallbackComponent = (): ReactNode => {
	// TODO use tag manager with data-layer to track the error
	return (
		<div {...stylex.props(styles.layout)}>
			<Header.Web />
			<UnexpectedError />
		</div>
	);
};

const RootComponent = () => {
	const { formatMessage } = useIntl();

	return (
		<>
			<GoogleTagManager />
			<ErrorBoundary FallbackComponent={FallbackComponent}>
				<div {...stylex.props(styles.layout)}>
					<Header.Web
						slotEnd={
							<Locale.Switcher
								subheader={formatMessage({
									id: "trip_tracking.common.description.choose_language",
									defaultMessage: "Choose your language",
									description: "Subheader text shown in the language switcher dropdown in the top navigation bar.",
								})}
							/>
						}
					/>
					<Outlet />
				</div>
			</ErrorBoundary>
		</>
	);
};

export const Route = createRootRoute({
	component: RootComponent,
});
